import { Injectable } from '@angular/core';
import { BullhornEntityTypes } from 'datasource-service-lib';
import { BullhornEntityMetadataService } from 'entity-metadata-service-lib';
import { IEntityTypeOption } from 'interfaces-lib';
import { map, Observable, of } from 'rxjs';

interface IEntityRelationshipEntry {
  parentEntity: BullhornEntityTypes;
  options: IEntityTypeOption[];
}

const ENTITY_RELATIONSHIPS: IEntityRelationshipEntry[] = [
  {
    parentEntity: BullhornEntityTypes.Candidate,
    options: [{ value: BullhornEntityTypes.Candidate, isDefault: true }],
  },
  {
    parentEntity: BullhornEntityTypes.JobOrder,
    options: [
      { value: BullhornEntityTypes.JobOrder, isDefault: true },
      { value: BullhornEntityTypes.ClientContact },
      { value: BullhornEntityTypes.ClientCorporation },
    ],
  },
  {
    parentEntity: BullhornEntityTypes.ClientContact,
    options: [{ value: BullhornEntityTypes.ClientContact, isDefault: true }, { value: BullhornEntityTypes.ClientCorporation }],
  },
  {
    parentEntity: BullhornEntityTypes.ClientCorporation,
    options: [{ value: BullhornEntityTypes.ClientCorporation, isDefault: true }],
  },
  {
    parentEntity: BullhornEntityTypes.JobSubmission,
    options: [
      { value: BullhornEntityTypes.JobSubmission, isDefault: true },
      { value: BullhornEntityTypes.Candidate },
      { value: BullhornEntityTypes.JobOrder },
    ],
  },
  {
    parentEntity: BullhornEntityTypes.Placement,
    options: [
      { value: BullhornEntityTypes.Placement, isDefault: true },
      { value: BullhornEntityTypes.Candidate },
      { value: BullhornEntityTypes.JobOrder },
      { value: BullhornEntityTypes.ClientCorporation },
      { value: BullhornEntityTypes.ClientContact },
    ],
  },
];

@Injectable({ providedIn: 'root' })
export class BullhornEntityTypeMappingsService {
  constructor(private entityMetadataService: BullhornEntityMetadataService) {}

  getEntityTypeOptions(parentEntityType: string): Observable<IEntityTypeOption[]> {
    const entry = ENTITY_RELATIONSHIPS.find((e) => e.parentEntity === parentEntityType);
    if (!entry) {
      return of([]);
    }
    return this.entityMetadataService.getEntitiesMetadata().pipe(
      map((metadata) =>
        entry.options.map((option) => ({
          value: option.value,
          label: metadata.find((m) => m.name === option.value)?.label ?? option.value,
          isDefault: option.isDefault,
        }))
      )
    );
  }
}
